import { l } from '../lib/imports'
import { assert } from '../lib/assert-sidecar'

export type MonsterType = 'error' | 'human' | 'slime'

export interface IMonsterData {
  type: MonsterType
  idx: number
  maxHp: number
  attackRate: number
  attackRecoveryDelay: number
  attackDamage: number
  regenerationRate: number
  canRespawn: boolean
  name: string
  isSpawnable: boolean
  range: number
  moveSpeed: number
  deathSpeed: number

  needsSuit: boolean
}

const defaultMonsterData = {
  type: 'error',
  idx: -1,
  maxHp: 10,
  attackDamage: 3,
  attackRate: 0.5,
  attackRecoveryDelay: 0.5,
  regenerationRate: 1.0,
  canRespawn: false,
  name: 'default',
  isSpawnable: false,
  range: 1,
  moveSpeed: 0.5,
  deathSpeed: 1.5,
  needsSuit: false,
}

export const dataList: IMonsterData[] = []
export const dataMapIdx: { [key: number]: IMonsterData } = {}
export const dataMapName: { [key: string]: IMonsterData } = {}

export function addMonster(
  idx: number,
  type: MonsterType,
  isSpawnable: boolean,
  name: string,
  data: Partial<IMonsterData>,
) {
  let d = Object.assign({}, defaultMonsterData, data, {
    idx,
    name,
    isSpawnable,
    type,
  })
  Object.freeze(d)
  dataList.push(d)
  dataMapIdx[idx] = d
  dataMapName[name] = d
}

export function getByType(type: MonsterType) {
  let d = l.find(dataList, (c) => c.type === type)
  assert.notNil(d, 'type not found', type)
  return d
}

export const createData = () => {
  addMonster(27, 'slime', true, 'Slime', {
    maxHp: 10,
  })
  addMonster(34, 'human', true, 'Guy', {
    maxHp: 100,
    moveSpeed: 0.25,
    needsSuit: true,
  })
  // addMonster(33, true, 'Suit', { maxHp: 30, moveSpeed: 0.33 })
  // addMonster(5, false, 'Dwarf', { maxHp: 3, moveSpeed: 1.5 })
  // addMonster(22, true, 'Rat', { maxHp: 1, moveSpeed: 0.2 })
  // addMonster(13, true, 'Goblin', {})
  // addMonster(26, true, 'Skeleton', { canRespawn: true, deathSpeed: 3 })
  // addMonster(23, true, 'Reaper', { maxHp: 30, moveSpeed: 0.25 })
  // addMonster(6, true, 'Dark Elf Archer', { range: 3, moveSpeed: 0.75 })
  // addMonster(28, true, 'Snake', { canRespawn: true })
}
